export const ADD_FLASH_MESSAGE = "ADD_FLASH_MESSAGE";
export const DELETE_FLASH_MESSAGE = "DELETE_FLASH_MESSAGE";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_PRODUCT = "SET_PRODUCT";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_COUNTRIES = "SET_COUNTRIES";
export const ADD_CART = "ADD_CART";
export const CLEAR_CART = "CLEAR_CART";
export const GET_CART_REQUEST_SUCESSS = "GET_CART_REQUEST_SUCESSS";
export const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
export const GET_ALL_ORDER_SUCCESS = "GET_ALL_ORDER_SUCCESS";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const SET_LOGGEDIN_USER = "SET_LOGGEDIN_USER";
export const SET_REDIRECT_PATH = "SET_REDIRECT_PATH";
export const CLEAR_ORDER_RESULT = "CLEAR_ORDER_RESULT";
export const SET_STORE_ADDRESS = "SET_STORE_ADDRESS";
export const GET_AUTO_RENEWALS_SUCCESS = "GET_AUTO_RENEWALS_SUCCESS";
export const GET_AUTO_RENEWAL_DETAIL_SUCCESS = "GET_AUTO_RENEWAL_DETAIL_SUCCESS";



// WEBPACK FOOTER //
// ./src/modules/actions/types.js